export const MS_1_MINUTE = 60 * 1000;
export const MS_2_MINUTE = 2 * 60 * 1000;
export const MS_5_MINUTES = 5 * 60 * 1000;
export const MS_10_MINUTES = 10 * 60 * 1000;
